import Axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";

import { Col, Collapse, List, Row, Table } from "antd";

import { Title } from "./styles";

import BreadCrumbs from "../../../../components/utils/breadCrumbs";
import { getPicketSupplementSupplyAndFeedReaderImportDetails } from "../../../../services/importService";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import ArrowActiveIcon from "../../animalCoverage/details/icons/arrow/active";
import ArrowInactiveIcon from "../../animalCoverage/details/icons/arrow/inactive";
import {
  Container,
  HeaderContainer,
} from "../../animalCoverage/details/styles";

function PicketSupplementSupplyAndFeedReaderImportDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [importLogData, setImportLogData] = useState(null);
  const [importItensData, setImportItensData] = useState([]);

  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const { id } = useParams();

  const customPanelStyle = {
    borderRadius: 7,
    background: "#fff",
    boxShadow: "0px 0px 10px #d8d8d8",
    marginBottom: 15,
  };

  const Column = Table.Column;

  const Header = (imported, amountRecords) => (
    <HeaderContainer>
      <div className="title">
        <span>
          {imported
            ? translation.imports.picketSupplementSupplyFeedReader.details
                .collapseImported
            : translation.imports.picketSupplementSupplyFeedReader.details
                .collapseNotImported}
        </span>
      </div>
      <div className="amountAnimals">
        <span>{`${amountRecords} ${translation.imports.picketSupplementSupplyFeedReader.details.records}`}</span>
      </div>
    </HeaderContainer>
  );

  const renderPicketNames = (record) => {
    if (
      record.entity == null ||
      record.entity.supplyPicketsInfo == null ||
      record.entity.supplyPicketsInfo.length === 0
    ) {
      return null;
    }
    const picketNames = record.entity.supplyPicketsInfo
      .map((info) => info.picketName)
      .filter(
        (picketName, index, self) =>
          picketName != null && self.indexOf(picketName) === index
      );
    return picketNames.join(", ");
  };

  const renderDate = (record) => {
    if (record.entity == null || record.entity.supplyDate == null) {
      return null;
    }
    return moment(record.entity.supplyDate, "YYYY-MM-DD").format("DD/MM/YYYY");
  };

  const renderType = (record) => {
    if (record.entity == null || record.entity.uploadType == null) {
      return null;
    }
    const types =
      translation.imports.picketSupplementSupplyFeedReader.details.types;
    return record.entity.uploadType === "SUPPLY"
      ? types.supply
      : record.entity.uploadType === "FEED_READER"
      ? types.feedReader
      : record.entity.uploadType === "SUPPLY_AND_FEED_READER"
      ? types.supplyAndFeedReader
      : record.entity.uploadType;
  };

  const getImportLogInfo = useCallback(async () => {
    const signal = Axios.CancelToken.source();
    setIsLoading(true);
    try {
      const {
        data: { results: importLogData },
      } = await getPicketSupplementSupplyAndFeedReaderImportDetails({
        groupId,
        farmId,
        id,
        signal,
      });
      setImportLogData(importLogData);
      const itens =
        importLogData.picketSupplyAndFeedReaders != null
          ? importLogData.picketSupplyAndFeedReaders
          : [];
      let importedData = itens.filter((item) => item.success).sort(compare);
      let notImportedData = itens
        .filter((item) => !item.success)
        .sort(compare);
      setImportItensData([
        {
          imported: true,
          total: importedData.length,
          data: importedData,
        },
        {
          imported: false,
          total: notImportedData.length,
          data: notImportedData,
        },
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [farmId, groupId, id]);

  useEffect(() => {
    getImportLogInfo();
    return () => {
      setImportLogData(null);
      setImportItensData([]);
    };
  }, [getImportLogInfo]);

  return (
    <Container>
      <BreadCrumbs marginBottom="16px">
        <Link to="/admin/imports?tabSelect=9">
          <span className="pageTreeInative">
            {
              translation.imports.picketSupplementSupplyFeedReader.details
                .breadCumbsImportLog
            }
          </span>
        </Link>
        <span className="pageTreeActive">
          {
            translation.imports.picketSupplementSupplyFeedReader.details
              .breadCumbsImportLogDetails
          }
        </span>
      </BreadCrumbs>
      <Row type="flex" justify="space-between" style={{ marginBottom: "19px" }}>
        <Col>
          <Title>
            {
              translation.imports.picketSupplementSupplyFeedReader.details
                .statusTitle
            }
            :{" "}
          </Title>
          {importLogData != null
            ? importLogData.status === "Processed"
              ? translation.imports.status.processed
              : importLogData.status === "Queue"
              ? translation.imports.status.queue
              : importLogData.status === "Processing"
              ? translation.imports.status.processing
              : importLogData.status === "Error"
              ? translation.imports.status.error
              : null
            : null}
        </Col>
        <Col>
          <Title>
            {
              translation.imports.picketSupplementSupplyFeedReader.details
                .fileNameTitle
            }
            :{" "}
          </Title>
          {importLogData != null ? importLogData.fileName : null}
        </Col>
        <Col>
          <Title>
            {
              translation.imports.picketSupplementSupplyFeedReader.details
                .dateTitle
            }
            :{" "}
          </Title>
          {importLogData != null ? importLogData.date : null}
        </Col>
      </Row>
      <List
        itemLayout="vertical"
        loading={isLoading}
        size="large"
        dataSource={importItensData != null ? importItensData : []}
        renderItem={(item) => (
          <Collapse
            bordered={false}
            expandIcon={({ isActive }) =>
              isActive ? <ArrowActiveIcon /> : <ArrowInactiveIcon />
            }
          >
            <Collapse.Panel
              header={Header(item.imported, item.total)}
              key={item.id}
              style={customPanelStyle}
            >
              <Row type="flex" justify="start">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Table
                    rowKey="rowNumber"
                    dataSource={item.data}
                    pagination={{
                      showSizeChanger: true,
                      pageSizeOptions: [
                        "10",
                        "20",
                        "30",
                        "100",
                        "500",
                        "1000",
                        "2000",
                      ],
                      defaultPageSize: 10,
                    }}
                    size="small"
                  >
                    <Column
                      title={
                        translation.imports.picketSupplementSupplyFeedReader
                          .details.table.columns.rowNumber
                      }
                      dataIndex="rowNumber"
                      key="rowNumber"
                      align="left"
                    />
                    <Column
                      title={
                        translation.imports.picketSupplementSupplyFeedReader
                          .details.table.columns.picket
                      }
                      key="picket"
                      align="left"
                      render={(text, record) => renderPicketNames(record)}
                    />
                    <Column
                      title={
                        translation.imports.picketSupplementSupplyFeedReader
                          .details.table.columns.date
                      }
                      key="date"
                      align="left"
                      render={(text, record) => renderDate(record)}
                    />
                    <Column
                      title={
                        translation.imports.picketSupplementSupplyFeedReader
                          .details.table.columns.type
                      }
                      key="type"
                      align="left"
                      render={(text, record) => renderType(record)}
                    />
                    {item.imported && (
                      <Column
                        title={
                          translation.imports.picketSupplementSupplyFeedReader
                            .details.table.columns.alert
                        }
                        align="left"
                        render={(text, record) =>
                          record.alerts != null ? (
                            <ol>
                              {record.alerts.map((e, index) => (
                                <li key={index}>{e}</li>
                              ))}
                            </ol>
                          ) : null
                        }
                      />
                    )}
                    {!item.imported ? (
                      <Column
                        title={
                          translation.imports.picketSupplementSupplyFeedReader
                            .details.table.columns.message
                        }
                        align="left"
                        render={(text, record) =>
                          record.errors != null ? (
                            <ol>
                              {record.errors.map((e, index) => (
                                <li key={`${index}_${record.rowNumber}`}>
                                  {e}
                                </li>
                              ))}
                            </ol>
                          ) : null
                        }
                      />
                    ) : null}
                  </Table>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        )}
      />
    </Container>
  );
}

export default PicketSupplementSupplyAndFeedReaderImportDetails;

function compare(a, b) {
  let comparison = 0;
  if (a.rowNumber > b.rowNumber) {
    comparison = 1;
  } else if (a.rowNumber < b.rowNumber) {
    comparison = -1;
  }
  return comparison;
}
